import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import logo from "../../assets/img/logo.png";
import { VscEyeClosed, VscEye } from 'react-icons/vsc';
import { MdError, MdClose } from 'react-icons/md';
import { baseUrl } from "../../shared/baseUrl";
import Swal from 'sweetalert2';

const Signup = () => {
  const navigate = useNavigate()

  const [seePassword, setSeePassword] = useState(false)
  const [seeConfirmPassword, setSeeConfirmPassword] = useState(false)
  const [showToast, setShowToast] = useState(false)

  // --- Signup States --- //
  const [firstname, setFirstname] = useState("")
  const [lastname, setLastname] = useState("")
  const [email, setEmail] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")

  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  useEffect(() => {
    if (userInfo) {
      navigate("/dashboard")
    }
    if(error) {
      setShowToast(true)
    }
    if(loading) {
      setShowToast(false)
    }
  }, [userInfo, error, loading])

  useEffect(() => {
    if(success) {
      Swal.fire({
        icon: 'success',
        title: 'Your account have been created!',
        text: "Redirecting to Login page...",
        timer: 3500,
        timerProgressBar: true,
        showConfirmButton: false,
      })

      setTimeout(() => {
        navigate("/login")
      }, 3000)
    }
  }, [success])

  const handleUserRegister = (e) => {
    e.preventDefault()

    if(password === confirmPassword) {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        }
      }
      const registerUser = async () => {
        try {
          setLoading(true)
          const res = await axios.post(
            baseUrl + "/api/v1/auth/register",{
              firstname,
              lastname,
              email,
              phoneNumber,
              username,
              password,
            }, config)
          setLoading(false)
          setSuccess(res.data.success)
        }
        catch(err){
          setError(err.response && err.response.data.message ? err.response.data.message : err.message)
          setLoading(false)
        }
      }
      registerUser()

    } else {
      setError("Passwords do not match!")
    }
  }

  return (
    <div id="login">
      <div className="container">
        <NavLink to="/" className="logo-area">
          <img src={logo} alt="Island Luxury" />
        </NavLink>
        <div className="login-form_cont">
          <h1>Sign up</h1>
          <form onSubmit={handleUserRegister}>
            <div className="form-grp">
              <label htmlFor="fName">First Name</label>
              <input 
                type="text" 
                id="fName" 
                required 
                value={firstname}
                onChange={(e) => setFirstname(e.target.value)} />
            </div>
            <div className="form-grp">
              <label htmlFor="lName">Last Name</label>
              <input 
                type="text" 
                id="lName" 
                required 
                value={lastname}
                onChange={(e) => setLastname(e.target.value)} />
            </div>
            <div className="form-grp">
              <label htmlFor="email">Email</label>
              <input 
                type="email" 
                id="email" 
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="form-grp">
              <label htmlFor="username">Username</label>
              <input 
                type="text" 
                id="username" 
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)} />
            </div>
            <div className="form-grp">
              <label htmlFor="tel">Mobile No: (Whatsapp)</label>
              <input 
                type="tel" 
                id="tel" 
                required 
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)} />
            </div>
            <div className="form-grp">
              <label htmlFor="password">Password</label>
              <input 
                type={seePassword ? "text" : "password"} 
                id="password" 
                required 
                value={password}
                onChange={(e) => setPassword(e.target.value)} />
              <div className="password-visibility" onClick={() => setSeePassword(!seePassword)}>
                {seePassword ? <VscEye /> : <VscEyeClosed />}
              </div>
            </div>
            <div className="form-grp">
              <label htmlFor="c-password">Confirm Password</label>
              <input 
                type={seeConfirmPassword ? "text" : "password"} 
                id="c-password" 
                required 
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)} />
              <div className="password-visibility" onClick={() => setSeeConfirmPassword(!seeConfirmPassword)}>
                {seeConfirmPassword ? <VscEye /> : <VscEyeClosed />}
              </div>
            </div>
            <button type="submit" disabled={loading && true}>{loading ? "Signing up..." : "Sign up"}</button>
            {showToast &&
              <div className="msg-toast error">
                <div>
                  <MdError size={20} />
                  <p>{error}</p>
                </div>
                <span onClick={() => setShowToast(false)}><MdClose size={20} /></span>
              </div>
            }
          </form>
          <div>
            <p>Already have an account? <NavLink to="/login">Login</NavLink></p>
          </div>
        </div>
        <div className="login-footer">
          <NavLink to="/terms">Terms</NavLink> |
          <NavLink to="/terms"> Privacy</NavLink> |
          <NavLink to="/contact"> Contact</NavLink>
        </div>
      </div>
    </div>
  )
}

export default Signup;